module.exports = __webpack_public_path__ + "static/background-090edaab07e33fd45ba71f0721faf9c9.png";